import { Button, Group, Modal, Text } from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";
import { IconCopy } from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { notifications } from "@mantine/notifications";
import BackButton from "../View/BackButton";
import { useParams } from "react-router-dom";

const SelectionDuplicator = ({
  getHandler,
  ids,
  setTableLoading,
  rows,
  closeMenu,
  apiRef
}) => {
  const lang = useLanguage((s) => s.language);
  const { folderId } = useParams();
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);

  const sharingForm = useForm({
    defaultValues: {
      sharing: [],
    },
  });

  const main = () => {
    setLoading(true);
    let requests = [];
    ids?.forEach((id) => {
      requests.push(
        new Promise((resolve, reject) => {
          let current = rows.find((x) => x.id === id);

          let handler = getHandler(current);
          handler({
            id,
          }).then((res) => {
            resolve();
          });
        })
      );
    });

    Promise.all(requests).finally(() => {
      sharingForm.reset();
      notifications.show({
        message: lang.contact_lists.duplicate.success,
        color: "tertiary.8",
      });
      close();
      setLoading(false);
      setTableLoading?.(true);
      closeMenu?.();
      if (apiRef?.current) {
        apiRef.current.setRowSelectionModel([]);
      }
    });
  };

  const getDisabled = () => {
    if (!rows) {
      return true;
    }
    if (ids.length === 0) {
      return true;
    }
    if (folderId) {
      return (
        ids.filter(
          (x) => !rows.find((r) => r.id === x)?.permission?.write_permission
        ).length > 0
      );
    }
    if (!folderId) {
      return (
        ids.filter((x) => !rows.find((r) => r.id === x)?.write_permission)
          .length > 0
      );
    }
    return false;
  };

  return (
    <>
      <Button
        variant="light"
        disabled={getDisabled()}
        onClick={open}
        leftSection={<IconCopy size={18} />}
        justify="start"
        className="to-blue"
      >
        {lang.contact_lists.duplicate.label_selection}
      </Button>

      <Modal
        opened={opened}
        onClose={close}
        title={lang.contact_lists.duplicate.title_selection.replace(
          "#",
          ids.length
        )}
        size={"md"}
      >
        <Text c={"dimmed"}>{lang.contact_lists.duplicate.text_selection}</Text>

        <Group justify="end" mt={"md"}>
          <BackButton onClick={close} />

          <Button
            leftSection={<IconCopy size={18} />}
            loading={loading}
            color="primary"
            onClick={main}
          >
            {lang.contact_lists.duplicate.dialog.submit_button}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default SelectionDuplicator;
